import React from "react";

export type TaskModalProps = {
    taskUUID: string;
    fromDate?: Date;
    toggle?: () => void;
    onOpenTask?: (taskUuid: string, fromDate?: Date) => void;
};

export interface IPlanScreenContext {
    filterPart: string
    searchTerm: string
    hideDone: boolean
    showOld: boolean
    justDonePlans: string[]
    /** Дни (yyyy-MM-dd), для которых отображение готовых задач переключено локально, вопреки hideDone */
    invertedDoneDays?: string[]
    planJustDone: (uuid: string) => void,
    setTaskModal: (props: TaskModalProps) => void
    movePlan: (planUUID: string, newDate: string) => void
    copyPlan: (planUUID: string, newDate: string) => void
    /**
     * Переключает отображение готовых задач отдельного дня.
     * Отсутствует, если экран не поддерживает локальное переключение (тогда счётчик некликабелен).
     */
    toggleDoneDay?: (dateKey: string) => void
}

export const PlanScreenContext = React.createContext<IPlanScreenContext>({
    filterPart: '',
    searchTerm: '',
    hideDone: true,
    showOld: false,
    justDonePlans: [],
    invertedDoneDays: [],
    planJustDone: (uuid) => null,
    setTaskModal: (props) => null,
    movePlan: (planUUID, newDate) => null,
    copyPlan: (planUUID, newDate) => null
})

